import React, { memo } from "react";
import styled from "styled-components";

import { HeaderLogo, HeaderLangs } from "~/src/components/header";
import {
    down,
    fonts,
    global,
    header,
    colors,
    spacings,
} from "~/src/config/vars";

let Header = () => {
    return (
        <SHeader>
            <SBlock>
                <HeaderLogo />
                <HeaderLangs />
            </SBlock>
        </SHeader>
    );
};

Header = memo(Header);

const SHeader = styled.header`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    pointer-events: none;
    z-index: ${global?.zi_header};
    ${down("sm")} {
    }
`;
const SBlock = styled.div`
    display: flex;
    align-items: center;
    height: ${header?.height};
    font-weight: ${fonts?.fw_medium};
    position: relative;
    padding: 0 ${spacings?.offset_wrapper};
    > div {
        pointer-events: all;
    }
    a {
        color: ${colors?.typo_primary};
        &:hover {
            color: ${colors?.typo_link};
        }
    }
`;

export default Header;
